import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const designExportJobsSummaryWrapper: ThemedFunctor = ({ theme }) => css`
  position: fixed;
  z-index: ${theme.zIndex.overthetop};
  bottom: ${theme.remSize[200]};
  right: ${theme.remSize[200]};
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.5));
`;
